import { Component, Shark } from "shark-mvc";

import templateContent from "./project-stats.html";


class ProjectStatsComponent extends Component {
	constructor () {
		super("projectStatsComponent");

		this.addTemplate("", templateContent);
	}
	
	// init () {
	// }
}

const projectStatsComponent = new ProjectStatsComponent();

Shark.registerComponent(projectStatsComponent);

export default projectStatsComponent;